export class CNNotification {

    constructor(
        public id: string,
        public title: string,
        public description: string,
        public onlyActive: string,
        public time: number = 0,
        public enabled: boolean = false,
        public monday?: boolean,
        public tuesday?: boolean,
        public wednesday?: boolean,
        public thursday?: boolean,
        public friday?: boolean,
        public saturday?: boolean,
        public sunday?: boolean,
        public mondayTime?: number,
        public tuesdayTime?: number,
        public wednesdayTime?: number,
        public thursdayTime?: number,
        public fridayTime?: number,
        public saturdayTime?: number,
        public sundayTime?: number,
    ) { }

}
